import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {OrganizationForm} from "../OrganizationForm";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum ORGANIZATION_MODAL_CONTENT {
  LOADING = 'loading',
  CONFIRM_DELETE = 'confirmDelete',
  MESSAGE = 'message',
  ORGANIZATION_FORM = 'organizationForm'
}

export const OrganizationModalContent = ({
  message,
  messageType,
  editingOrganization,
  userRole,
  userOrganizationGroup,
  currentOrganization,
  deletingOrganizationId,
  handleCloseDialog,
  handleDeleteOrganization,
  handleChangeOrganizationName,
  handleChangeOrganizationGroupName,
  handleSaveOrganization
}) => ({
  [ORGANIZATION_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="載入中"/>
  ),
  [ORGANIZATION_MODAL_CONTENT.CONFIRM_DELETE]: (
    <TwoButtonDialog
      type="warning"
      title="確定要刪除此業務組別嗎？\n此動作將無法復原"
      leftLabel="不刪除"
      leftOnClick={handleCloseDialog}
      rightLabel="刪除"
      rightOnClick={() => handleDeleteOrganization(deletingOrganizationId)}
      rightIconName="fa-trash"
      rightColor="warning"
    />
  ),
  [ORGANIZATION_MODAL_CONTENT.MESSAGE]: (
    <TwoButtonDialog
      type={messageType}
      title={message}
      leftLabel={"OK"}
      leftOnClick={handleCloseDialog}
      leftIconName="fa-check"
    />
  ),
  [ORGANIZATION_MODAL_CONTENT.ORGANIZATION_FORM]: (
    <OrganizationForm
      organization={currentOrganization}
      onChangeName={e => handleChangeOrganizationName(e.target.value)}
      onChangeGroup={groupName => handleChangeOrganizationGroupName(groupName)}
      onClickSave={handleSaveOrganization}
      mode={editingOrganization}
      userRole={userRole}
      userOrganizationGroup={userOrganizationGroup}
    />
  )
});
